function c(t, e) {
  return t === e ? t !== 0 || 1 / t === 1 / e : t !== t && e !== e;
}
const n = typeof Object.is == "function" ? Object.is : c;
export {
  n as default
};
